import * as styles from './styles/styles.module.scss';

const MarkerPositionTooltip = ({ text }: { text: string }) => <div className={styles.tooltip}>{text}</div>

export default MarkerPositionTooltip;